import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "callback",
  "use": "callback-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"callback\"><path d=\"M435 234l-48-48s0-4 3-4c36-35 74-73 109-108 0 0 3 0 3-4 0 0-3 0-3-3L432 0s0-3-3-3h-3l-4 3c-35 35-73 74-108 109l-4 3-48-48v166l173 4c0 3 0 0 0 0zm71 176l-112-68c-7-3-16-3-20 4l-32 32c-3 3-12 9-19 9 0 0-41 0-121-77-80-76-80-121-80-121 0-7 3-16 9-19l29-29c3-3 6-13 3-19L102 6c-3-6-9-9-16-3L10 80C6 83 0 93 0 99c0 0-16 112 141 269s269 141 269 141c6 0 16-7 19-10l77-77c9-3 6-9 0-12z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/callback.svg
// module id = 184
// module chunks = 0